export type InventoryAmlMpnAlternate = {
  id: string;
  manufacturer_name: string | null;
  mpn: string;
};

export function requiresInventoryMpnSelection(alternates: InventoryAmlMpnAlternate[]): boolean {
  return alternates.length > 1;
}

export function formatInventoryAmlMpnLabel(alternate: InventoryAmlMpnAlternate): string {
  const manufacturer = alternate.manufacturer_name?.trim() ?? "";
  return manufacturer !== "" ? `${manufacturer} · ${alternate.mpn}` : alternate.mpn;
}

/** Resolved MPN label for a carton or location row when alternates are loaded. */
export function inventoryBoxSavedMpnLabel(
  box: { approved_component_id: string | null },
  alternates: InventoryAmlMpnAlternate[],
): string | null {
  if (alternates.length === 0) return null;
  const resolvedId = resolveInventoryApprovedComponentId({
    alternates,
    savedApprovedComponentId: box.approved_component_id,
    draftApprovedComponentId: null,
  });
  if (resolvedId == null) return null;
  const match = alternates.find((row) => row.id === resolvedId);
  return match != null ? formatInventoryAmlMpnLabel(match) : null;
}

export function resolveInventoryApprovedComponentId(input: {
  alternates: InventoryAmlMpnAlternate[];
  savedApprovedComponentId: string | null;
  draftApprovedComponentId: string | null | undefined;
}): string | null {
  if (input.draftApprovedComponentId != null && input.draftApprovedComponentId.trim() !== "") {
    return input.draftApprovedComponentId;
  }
  if (input.savedApprovedComponentId != null && input.savedApprovedComponentId.trim() !== "") {
    return input.savedApprovedComponentId;
  }
  if (input.alternates.length === 1) {
    return input.alternates[0]!.id;
  }
  return null;
}

export function inventoryMpnSelectionSatisfied(input: {
  alternates: InventoryAmlMpnAlternate[];
  approvedComponentId: string | null;
}): boolean {
  if (input.alternates.length === 0) return true;
  if (input.alternates.length === 1) {
    if (input.approvedComponentId == null || input.approvedComponentId.trim() === "") {
      return true;
    }
    return input.approvedComponentId === input.alternates[0]!.id;
  }
  if (input.approvedComponentId == null || input.approvedComponentId.trim() === "") return false;
  return input.alternates.some((row) => row.id === input.approvedComponentId);
}

export function inventorySavedMpnNotOnAml(input: {
  alternates: InventoryAmlMpnAlternate[];
  savedApprovedComponentId: string | null;
}): boolean {
  if (input.alternates.length === 0) return false;
  const saved = input.savedApprovedComponentId?.trim() ?? "";
  if (saved === "") return false;
  return !input.alternates.some((row) => row.id === saved);
}
